import { v4 as uuidv4 } from "uuid";

export const DEVICE_UUID_STORAGE_KEY = "uuid_device";

export function getDeviceUuid() {
  const savedDeviceUuid = localStorage.getItem(DEVICE_UUID_STORAGE_KEY);

  if (savedDeviceUuid) {
    return savedDeviceUuid;
  }

  const deviceUuid =
    typeof globalThis.crypto?.randomUUID === "function"
      ? globalThis.crypto.randomUUID()
      : uuidv4();

  localStorage.setItem(DEVICE_UUID_STORAGE_KEY, deviceUuid);
  return deviceUuid;
}
